import type { ProductIntegrationEntity } from '@vy/types';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';

type UpdateProductIntegrationEntitiesParams = {
  productId: string;
  integrationEntities: ProductIntegrationEntity[];
};

export function useUpdateProductIntegrationEntities(
  options?: UseMutationOptions<void, unknown, UpdateProductIntegrationEntitiesParams>,
) {
  return useMutation({
    mutationFn: async ({ productId, integrationEntities }) => {
      const api = getPrivateApi();

      await api.updateProductIntegrationEntities({
        productId,
        updateProductIntegrationEntitiesRequest: { integrationEntities },
      });
    },
    ...options,
  });
}
